import React, {  useState } from 'react';
import { Container, Typography, Card, Tab, Box, Stack } from '@mui/material';
import {  TabContext, TabList, TabPanel } from '@mui/lab';
import Page from '../components/Page';
import RefundPending from '../components/RefundPending';
import RefundCompleted from '../components/RefundCompleted';


export default function Refunds() {
  const [value, setValue] = useState('1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Page title="Refunds">
      <Container  maxWidth="xl">
        <Stack direction="row" spacing={2}>
          <Typography paddingBottom={1} variant="h5">
            Refunds
          </Typography>
        </Stack>
        <Card>
          <Box sx={{ width: '100%', marginTop: '20px' }}>
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleChange}>
                  <Tab label="PENDING" value="1" />
                  <Tab label="SUCCESS" value="2" />
                </TabList>
              </Box>
              <TabPanel value="1">
                <RefundPending  />
              </TabPanel>
              <TabPanel value="2">
                <RefundCompleted  />
              </TabPanel>
            </TabContext>
          </Box>
        </Card>
      </Container>
    </Page>
  );
}
